import { render, staticRenderFns } from "./individual_tax.vue?vue&type=template&id=b8a23f74&scoped=true&"
import script from "./individual_tax.vue?vue&type=script&lang=js&"
export * from "./individual_tax.vue?vue&type=script&lang=js&"
import style0 from "@/styles/index.scss?vue&type=style&index=0&id=b8a23f74&prod&lang=scss&scoped=true&"
import style1 from "./individual_tax.vue?vue&type=style&index=1&id=b8a23f74&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a23f74",
  null
  
)

export default component.exports